import { createContext, useContext } from 'react';
import type { AddDialogKind } from './nav';

/** Wartości domyślne formularza „Dodaj…” (np. „Nowe zadanie dla REA” z ⌘K). */
export interface AddDialogDefaults {
  clientId?: string | null;
  projectId?: string | null;
}

/** „Napisz do: …” z ⌘K (Figma 13): nowa wiadomość do klienta z adresatem (kompozytor poczty, wysyłka przez Akceptację). */
export interface ComposeDefaults {
  clientId: string;
  to: { email: string; name?: string }[];
}

export interface ShellActions {
  /** Otwiera ⌘K; `mode: 'add'` pokazuje od razu akcje „Dodaj…”. */
  openCommandPalette: (mode?: 'all' | 'add') => void;
  /** Otwiera panel „Menu” na telefonie (MobileMenu, wpis w historii — Wstecz zamyka). */
  openMobileMenu: () => void;
  /** Czy panel „Menu” na telefonie jest otwarty (aria-expanded przycisku Menu); brak = zamknięty. */
  mobileMenuOpen?: boolean;
  /** Otwiera formularz modułu w miejscu (zadanie, klient, projekt, zasób). */
  openAddDialog: (kind: AddDialogKind, defaults?: AddDialogDefaults) => void;
  /** Otwiera kompozytor nowej wiadomości (moduł Inbox: Edycja). */
  openComposer: (defaults: ComposeDefaults) => void;
}

export const ShellContext = createContext<ShellActions>({
  openCommandPalette: () => {},
  openMobileMenu: () => {},
  openAddDialog: () => {},
  openComposer: () => {},
});

export function useShell(): ShellActions {
  return useContext(ShellContext);
}
